import { call, put, takeLatest } from 'redux-saga/effects';

import { digitalAddItemRequest, digitalDeleteItemRequest, digitalUpdateError, digitalUpdateItemRequest, digitalUpdateRequest, digitalUpdateStore } from './digitalActions.js';
import { addDigitalItemApiCall, deleteDigitalItemApiCall, updateDigitalBlockApiCall, updateDigitalItemApiCall } from './digitalAPI.js';

function* updateDigitalSaga({ payload }) {
  try {
    yield call(updateDigitalBlockApiCall, payload);
    yield put(digitalUpdateStore());
  } catch (error) {
    yield put(digitalUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* addDigitalItemSaga({ payload }) {
  try {
    yield call(addDigitalItemApiCall, payload);
    yield put(digitalUpdateStore());
  } catch (error) {
    yield put(digitalUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* updateDigitalItemSaga({ payload }) {
  try {
    const { id, ...data } = payload;
    yield call(updateDigitalItemApiCall, id, data);
    yield put(digitalUpdateStore());
  } catch (error) {
    yield put(digitalUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* deleteDigitalItemSaga({ payload }) {
  try {
    yield call(deleteDigitalItemApiCall, payload);
    yield put(digitalUpdateStore());
  } catch (error) {
    yield put(digitalUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsDigitalWatcher() {
  yield takeLatest(digitalUpdateRequest.type, updateDigitalSaga);
  yield takeLatest(digitalAddItemRequest.type, addDigitalItemSaga);
  yield takeLatest(digitalUpdateItemRequest.type, updateDigitalItemSaga);
  yield takeLatest(digitalDeleteItemRequest.type, deleteDigitalItemSaga);
}
